<template>
  <div class="expenses">
    <h1 v-if="!isMobile">{{ $t('message.expenses') }}</h1>
    <div v-else style="margin-top: 20px;" />
    <div class="search-area">
      <input
        class="search-box"
        placeholder="Merchant, Type, Driver, or Vehicle"
        type="text"
      />
      <SearchIcon class="search-icon" />
      <button>
        <svg id="gfs:icon1/i-schedule" viewBox="0 0 24 24">
          <path d="M15.775 19.108l-.883-.883 1.483-1.483v-1.967h1.25v2.5l-1.85 1.833zm-3.333 1.85h-9.4V3.875h4.166V2.833h1.25v1.042h7.084V2.833h1.25v1.042h4.166v8.575a5.767 5.767 0 0 0-1.25-.833V9.175c-.2.076-.411.116-.625.117H4.917c-.214-.001-.426-.04-.625-.117v10.533h7.316c.225.452.508.872.842 1.25h-.008zM4.292 7.417c.004.343.281.62.625.625h14.166a.633.633 0 0 0 .625-.625V5.125h-2.916v1.042h-1.25V5.125H8.458v1.042h-1.25V5.125H4.292v2.292zM21.792 17A4.792 4.792 0 1 0 17 21.792 4.8 4.8 0 0 0 21.792 17zm-1.25 0A3.542 3.542 0 1 1 17 13.458 3.55 3.55 0 0 1 20.542 17z"></path>
        </svg>
        Jul 6, 2023 – Jul 13, 2023
      </button>
    </div>
    <div class="gradient-divider" />
    <DataTable
      :data="selectedExpenses"
      :columnsToShow="columnsToShow"
      @row-clicked="handleRowClick"
    >
      <template v-slot:attachment>
        <img src="@/assets/no-image.svg?external" class="no-image" />
      </template>
      <template v-slot:type="{ obj }">
        <span class="data status">
          <div class="connected-dot" style="background-color: #DC8B12;" />
          {{ $t(`message.${camelize(obj.type)}`) }}
        </span>
      </template>
      <template v-slot:status="{ obj }">
        <span class="data status">
          <div class="connected-dot" />
          {{ $t(`message.${camelize(obj.status)}`) }}
        </span>
      </template>
    </DataTable>
    <ModalForm
      :header="currentExpenseLabel"
      :fields="newExpenseModalFields"
      :data="selectedRow"
      :button1="Object.keys(selectedRow).length ? 'Delete Expense' : ''"
      button2="Save"
      :maxColumns="3"
      class="modal-form"
    >
      <template v-slot:upload>
        <div class="upload-area">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>image</title>
            <path d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z" />
          </svg>
          {{ $t('message.uploadImage') }}
        </div>
      </template>
      <template v-slot>
        <div class="created-by">
          <div class="left">
            <div>{{ $t('message.createdBy') }}</div>
            <div class="created-by-info">
              <svg id="gml:icon1/clock-picker" viewBox="0 0 24 24">
                <path d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z"></path>
              </svg>
              <span>Jan 28, 2023</span>
              <img src="@/assets/systemExpense.svg?external" />
              <span>{{ $t('message.system') }}</span>
            </div>
          </div>
          <b>{{ selectedRow && selectedRow.type ? $t(`message.${camelize(selectedRow.type)}`) : '' }} {{ $t('message.event') }}</b>
        </div>
      </template>
    </ModalForm>
    <!-- <div class="main">
      <img src="@/assets/expenses.svg?external" />
      <p>{{ $t('message.noResultsWereFound') }}</p>
      <div class="action-button">{{ $t('message.addExpenses') }}</div>
      <div class="action-button minor">
        <svg id="gfs:icon1/upload-file" viewBox="0 0 24 24">
          <path
            d="M13.988 2.249h.043l.298.001 2.259 2.277L20.53 8.47c.048.048.088.099.12.153l.1.102.001.244v.03L20.75 21.75H14v-1.5h5.25V9.75H14c-.38 0-.693-.282-.743-.648L13.25 9l-.001-5.25H6c-.118 0-.217.082-.243.193L5.75 4v16.25H9.5v1.5H4.25V4c0-.918.707-1.671 1.606-1.744L6 2.25zm-2.204 8.64l3.787 3.788c-.586.586-1.535.586-2.121 0l-.95-.95v8.023H11v-7.957l-.879.88c-.585.586-1.535.586-2.121 0l3.784-3.783zm2.966-6.078V8.25h3.417l-2.615-2.637-.802-.802z">
          </path>
        </svg>
        {{ $t('message.addExpensesFromFile') }}
      </div>
    </div> -->
    <GuidedTourWaypoint :id="12" bottomCircle />
  </div>
</template>

<script>
import DataTable from '@/components/demo/DataTable.vue';
import ModalForm from '../../components/demo/ModalForm.vue';
import SearchIcon from "@/assets/search-icon.svg";

import { camelize } from '../../utils/camelize';
import GuidedTourWaypoint from '../../components/demo/GuidedTourWaypoint.vue';

export default {
  components: {
    DataTable,
    ModalForm,
    SearchIcon,
    GuidedTourWaypoint
},
  props: {
    dataset: Object,
    isMobile: Boolean,
  },
  data() {
    return {
      camelize,
      columnsToShow: [
        {
          translationKey: "message.attachment",
          slot: "attachment",
          width: 100,
          fleet: true,
          dealer: false,
        },
        {
          translationKey: "message.expenseType",
          slot: "type",
          width: 125,
          fleet: true,
          dealer: false,
        },
        {
          translationKey: "message.expenseDate",
          dataKey: "date",
          width: 125,
          fleet: true,
          dealer: false,
        },
        {
          translationKey: "message.merchant",
          dataKey: "merchant",
          width: 125,
          fleet: true,
          dealer: false,
        },
        {
          translationKey: "message.driver",
          dataKey: "driver",
          width: 125,
          fleet: true,
          dealer: false,
        },
        {
          translationKey: "message.vehicle",
          dataKey: "vehicle",
          width: 170,
          fleet: true,
          dealer: false,
        },
        {
          translationKey: "message.fleet",
          dataKey: "fleet",
          width: 125,
          fleet: true,
          dealer: false,
        },
        {
          translationKey: "message.status",
          slot: "status",
          width: 125,
          fleet: true,
          dealer: false,
        },
        {
          translationKey: "message.createdOn",
          dataKey: "createdOn",
          width: 125,
          fleet: true,
          dealer: false,
        },
        {
          translationKey: "message.createdBy",
          dataKey: "createdBy",
          width: 125,
          fleet: true,
          dealer: false,
        },
        {
          translationKey: "message.editedBy",
          dataKey: "editedBy",
          width: 125,
          fleet: true,
          dealer: false,
        },
        {
          translationKey: "message.amount",
          dataKey: "amount",
          width: 125,
          fleet: true,
          dealer: false,
        },
      ],
      selectedRow: {},
      newExpenseModalFields: [
        {
          label: '',
          slot: 'upload',
          wide: true,
        },
        {
          label: 'Expense Type',
          type: 'text',
          placeholder: 'Select',
          dataKey: 'type',
          required: true,
          disabled: true,
        },
        {
          label: 'Merchant',
          type: 'text',
          placeholder: 'Merchant name',
          dataKey: 'merchant',
        },
        {
          label: 'Amount',
          type: 'text',
          placeholder: '$  00.00',
          dataKey: 'amount',
          required: true,
        },
        {
          label: 'Date',
          type: 'date',
          placeholder: new Date().toLocaleDateString('en-US'),
          dataKey: 'dateRaw',
          required: true,
          disabled: true,
        },
        {
          label: 'Fleet',
          type: 'search',
          placeholder: 'Search...',
          dataKey: 'fleet',
          required: true,
        },
        {
          label: '',
          slot: 'none',
        },
        {
          label: 'Vehicle',
          type: 'search',
          placeholder: 'Search VIN...',
          dataKey: 'vehicle',
          disabled: true,
        },
        {
          label: 'Driver',
          type: 'search',
          placeholder: 'Search...',
          dataKey: 'driver',
        },
        {
          label: 'Description',
          type: 'bigtext',
          wide: true,
        },
      ],
    };
  },
  computed: {
    showModal() {
      return this.$store.state.showModal;
    },
    currentExpenseLabel() {
      const type = this.selectedRow.type || '';
      const typeCapitalized = type.charAt(0).toUpperCase() + type.slice(1);
      const date = new Date(`${this.selectedRow?.dateRaw}T09:00:00.000-04:00`);
      if (date instanceof Date && !isNaN(date)) {
        const dateStr = date.toLocaleDateString('en-US', {
          year: 'numeric',
          day: '2-digit',
          month: 'short',
        });
        return `${typeCapitalized} ${this.$t('message.expense')} | ${dateStr}`;
      }
      return 'New Expense';
    },
    inEssentialsMode() {
      return this.$store.state.inEssentialsMode;
    },
    selectedExpenses() {
      if (this.inEssentialsMode) return this.dataset.expenses.filter((expense) => expense.type === 'Charging');
      return this.dataset.expenses;
    }
  },
  methods: {
    handleRowClick(obj) {
      this.selectedRow = obj;
      this.$store.commit('toggleModal');
    },
  },
  watch: {
    showModal() {
      if (!this.showModal) this.selectedRow = {};
    },  
  },
}
</script>

<style lang="scss" scoped>
.expenses {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10%;
  p {
    color: #606164;
    margin-bottom: 32px;
  }
}

.action-button {
  width: 218px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid var(--blue);
  background-color: var(--blue);
  color: var(--white);
  // margin-left: 24px;
  // margin-right: 4px;
  margin-bottom: 16px;
  padding: 0 8px;
}

.action-button.minor {
  background-color: var(--white);
  border-color: var(--light-grey);
  color: var(--blue);
  // width: 106px;
  // margin-right: 0;
  svg {
    width: 18px;
    fill: var(--blue);
    margin-right: 8px;
  }
}
.no-image {
  height: 40px !important;
}

.upload-area {
  background-color: rgba(105, 205, 255, 0.12);
  // height: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: var(--blue);
  svg {
    width: 18px;
    margin-right: 8px;
    path {
      fill: var(--blue);
    }
  }
}

.modal-form {
  ::v-deep button {
    width: 140px;
    padding: 6px 0;
  }
  ::v-deep button.button1 {
    color: var(--red);
    border-color: var(--red);
    margin-right: auto;
  }
}

.created-by {
  margin-top: -15px;
  padding: 0 30px 15px 30px;
  color: #76777a;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .created-by-info {
    margin-top: 4px;
    display: flex;
    gap: 4px;
    svg {
      width: 16px;
      path {
        fill: #76777a;
      }
    }
    img {
      margin-left: 4px;
    }
  }
  b {
    color: var(--blue);
    font-size: 15px;
    font-weight: 600;
  }
}
.search-area {
  position: relative;
  width: 400px;
  .search-box {
    box-sizing: border-box;
    width: 100%;
    max-width: unset;
  }
  .search-icon {
    position: absolute;
    top: 5px;
    right: 8px;
    width: 18px;
    fill: #9d9da1;
  }
  button {
    position: absolute;
    top: 0;
    left: calc(100% + 8px);
    height: 26px;
    white-space: nowrap;
    background-color: white;
    border: 1px solid rgba(0, 28, 56, 0.24);
    border-radius: 4px;
    color: #05b5e4;
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: ProximaNova;
    font-weight: 600;
  }
  svg {
    width: 18px;
    fill: #05b5e4;
  }
}

</style>